import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['triggerText', 'triggerIcon', 'option']

  connect() {
    const selected =
      this.optionTargets.find(o => o.dataset.selected === 'true') ||
      this.optionTargets[0]

    if (selected) this.activate(selected.dataset.value, false)
  }

  select(event) {
    this.activate(event.currentTarget.dataset.value)
  }

  activate(value, dispatch = true) {
    if (!value) return

    this.optionTargets.forEach(opt => {
      opt.dataset.selected = (opt.dataset.value === value).toString()
    })

    const selected = this.optionTargets.find(o => o.dataset.value === value)
    if (!selected) return

    if (this.hasTriggerTextTarget) {
      this.triggerTextTarget.textContent = selected.dataset.text
    }

    if (this.hasTriggerIconTarget) {
      const icon = selected.querySelector('img')

      if (icon) {
        this.triggerIconTarget.src = icon.src
        this.triggerIconTarget.alt = icon.alt
        this.triggerIconTarget.hidden = false
      } else {
        this.triggerIconTarget.hidden = true
      }
    }

    if (dispatch) this.dispatch('change', { detail: { value } })
  }
}
